import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import { v4 as uuidv4 } from 'uuid'

import style from './Modal.module.css'

function Modal({
  className,
  isOpen,
  children,
  size = 'md',
  id,
  label,
  testId
}) {
  if (!isOpen) {
    return null
  }
  const overlayRef = useRef()
  useEffect(() => {
    const trapFocusInsideModal = (event) => {
      if (overlayRef?.current) {
        const focusableElements = Array.from(
          overlayRef.current.querySelectorAll(
            'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
          )
        ).filter(
          (el) =>
            !el.hasAttribute('disabled') &&
            !el.getAttribute('aria-hidden') &&
            el.tagName.toLowerCase() !== 'use'
        )

        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (
            !event.shiftKey &&
            document.activeElement === lastElement
          ) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }
    }

    if (isOpen) {
      overlayRef.current.focus()
      document.addEventListener('keydown', trapFocusInsideModal, false)
    } else {
      document.removeEventListener('keydown', trapFocusInsideModal, false)
    }
    return () => {
      document.removeEventListener('keydown', trapFocusInsideModal, false)
    }
  }, [isOpen])

  const generatedId = uuidv4()
  return (
    <div
      role='dialog'
      ref={overlayRef}
      id={id || generatedId}
      aria-labelledby={label}
      aria-modal='true'
      aria-label={label}
      className={classNames(style.modal)}
      data-testid={testId}
      tabIndex='-1'
    >
      <div
        className={classNames(style.container, style[size], className)}
        data-testid={'modalContainer'}
      >
        {children}
      </div>
    </div>
  )
}

export default Modal
